console.log("✅ NT FAIRING FILTER JS LOADED");

(function () {
  function slugify(text) {
    return String(text || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999; path=/";
  }

  class Filter {
    constructor(container) {
      this.container = container;
      this.dataUrls = (container.dataset.urls || "").trim();
      this.collectionPosition = Number(container.dataset.collectionPosition || 0);
      this.fields = Array.from(container.querySelectorAll(".chosen-container[data-field-index]"))
        .sort(function (a, b) {
          return Number(a.dataset.fieldIndex) - Number(b.dataset.fieldIndex);
        });

      this.buttonSubmit = container.querySelector(".js-btn-submit");
      this.buttonReset = container.querySelector(".js-btn-reset");
      this.rootData = [];
      this.levelData = [];

      this.loadData();
    }

    loadData() {
      var self = this;

      if (!this.dataUrls) {
        console.error("Filter data-urls is empty");
        return;
      }

      Promise.all(
        this.dataUrls.split(",").map(function (url) {
          return fetch(url.trim()).then(function (res) {
            if (!res.ok) throw new Error("JSON load failed: " + url);
            return res.json();
          });
        })
      )
        .then(function (data) {
          self.rootData = data.flat ? data.flat(2) : [].concat.apply([], data);
          self.levelData[0] = self.rootData;
          self.initField(self.fields[0], self.rootData);
          self.restoreCookie();
          self.bindEvents();
          console.log("✅ NT Filter initialized");
        })
        .catch(function (err) {
          console.error("NT Filter JSON error:", err);
        });
    }

    getDisplayValue(item) {
      if (item && typeof item === "object" && item.name) return item.name;
      return item;
    }

    initField(field, data) {
      if (!field) return;

      var results = field.querySelector(".chosen-results");
      if (!results) return;

      results.innerHTML = "";

      if (!Array.isArray(data)) return;

      data.forEach((item) => {
        var value = this.getDisplayValue(item);
        var li = document.createElement("li");
        li.className = "active-result";
        li.textContent = String(value).toUpperCase();
        li.dataset.value = value;
        results.appendChild(li);
      });

      field.classList.add("active");
    }

    resetField(field) {
      if (!field) return;

      var title = field.querySelector(".js-title");
      var results = field.querySelector(".chosen-results");

      field.dataset.value = "";
      field.classList.remove("active");

      if (title) title.textContent = title.dataset.placeholder || "";
      if (results) results.innerHTML = "";
    }

    resetFieldsFrom(index) {
      for (var i = index - 1; i < this.fields.length; i++) {
        this.resetField(this.fields[i]);
      }
      this.levelData.length = index;
    }

    onSelect(fieldIndex, value) {
      var field = this.fields[fieldIndex - 1];
      var title = field.querySelector(".js-title");
      var drop = field.querySelector(".chosen-drop");

      field.dataset.value = value;
      if (title) title.textContent = String(value).toUpperCase();
      if (drop) drop.classList.remove("active");

      this.resetFieldsFrom(fieldIndex + 1);

      if (fieldIndex >= this.fields.length) return;

      var currentData = this.levelData[fieldIndex - 1];
      if (!Array.isArray(currentData)) return;

      var found = currentData.find(function (item) {
        return item && item.name && String(item.name).toLowerCase() === String(value).toLowerCase();
      });

      if (!found) return;

      var nextKey = "field_" + (fieldIndex + 1);
      var nextData = found[nextKey];

      if (!nextData) return;

      this.levelData[fieldIndex] = nextData;
      this.initField(this.fields[fieldIndex], nextData);
    }

    getValues() {
      return this.fields.map(function (field) {
        return field.dataset.value || "";
      });
    }

    getFilterUrl(values) {
      var cp = Math.max(0, Math.min(this.collectionPosition, values.length - 1));
      var collectionSlug = slugify(values[cp]);

      var tags = values
        .map(function (value, index) {
          return index === cp ? null : slugify(value);
        })
        .filter(Boolean)
        .join("+");

      return "/collections/" + collectionSlug + "/" + tags;
    }

    bindEvents() {
      var self = this;

      this.container.querySelectorAll(".chosen-single").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var drop = btn.parentElement.querySelector(".chosen-drop");
          if (drop) drop.classList.toggle("active");
        });
      });

      this.container.addEventListener("click", function (e) {
        var li = e.target.closest(".active-result");
        if (!li) return;

        var field = li.closest(".chosen-container");
        var index = Number(field.dataset.fieldIndex);
        self.onSelect(index, li.dataset.value);
      });

      this.container.querySelectorAll("input[name='search']").forEach(function (input) {
        input.addEventListener("input", function () {
          var value = input.value.toLowerCase();
          var results = input.closest(".chosen-drop").querySelectorAll(".active-result");

          results.forEach(function (item) {
            item.style.display = item.textContent.toLowerCase().includes(value) ? "block" : "none";
          });
        });
      });

      document.addEventListener("click", function (e) {
        if (!self.container.contains(e.target)) {
          self.container.querySelectorAll(".chosen-drop.active").forEach(function (drop) {
            drop.classList.remove("active");
          });
        }
      });

      if (this.buttonReset) {
        this.buttonReset.addEventListener("click", function (e) {
          e.preventDefault();
          self.fields.forEach(function (field) {
            self.resetField(field);
          });
          self.levelData = [self.rootData];
          self.initField(self.fields[0], self.rootData);
          deleteCookie("arn-filter");
        });
      }

      if (this.buttonSubmit) {
        this.buttonSubmit.addEventListener("click", function (e) {
          e.preventDefault();

          var values = self.getValues();

          if (values.some(function (v) { return !v; })) {
            alert("Please select all filter options.");
            return;
          }

          setCookie("arn-filter", values, 7);
          window.location.href = self.getFilterUrl(values);
        });
      }
    }

    restoreCookie() {
      var values = getCookie("arn-filter");
      if (!Array.isArray(values) || values.length !== this.fields.length) return;

      deleteCookie("arn-filter");
    }
  }

  window.Filter = Filter;

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-filter-container").forEach(function (container) {
      new Filter(container);
    });
  });
})();